import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import qr5000 from '../assets/qr5000.png'; // <-- add this
import './CSS/Login.css';

const UploadSlip5000 = ({ history }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    setMessage('');
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/png')) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile)); // Generate preview URL
      setMessage('');
      setIsSuccess(false);
    } else {
      setMessage('Please upload a valid JPEG or PNG file.');
      setFile(null);
      setPreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage('Please upload a payment slip before submitting.');
      return;
    }

    const formData = new FormData();
    formData.append('paymentSlip', file);

    try {
      const verifyResponse = await fetch('/verify-slip5000', {
        method: 'POST',
        body: formData,
      });

      if (verifyResponse.ok) {
        const data = await verifyResponse.json();
        setMessage('Your Payment is valid!!');
        setIsSuccess(true);

        setTimeout(() => {
          history.push('/logincredits5000');
        }, 2000);
      } else {
        const error = await verifyResponse.json();
        setMessage(`Error: ${error.message}`);
        setIsSuccess(false);
      }
    } catch (error) {
      setMessage('An error occurred while uploading the file.');
      setIsSuccess(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '0 auto', padding: '20px' }}>
      <img className="logo" src={logo} alt="Logo" />
      <br />
      <div><Link to="/">Home</Link></div>
      <br />
      <h2>Upload Payment Slip</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="fileInput">Select Payment Slip (JPEG/PNG):</label>
          <input
            type="file"
            id="fileInput"
            accept="image/jpeg, image/png"
            onChange={handleFileChange}
            style={{ display: 'block', margin: '10px 0' }}
          />
        </div>

        {/* QR for 1000 payment */}
        <div style={{ marginTop: '12px', textAlign: 'center' }}>
          <div style={{ fontSize: '14px', marginBottom: '6px' }}>
            Or scan this QR code then upload your slip from your mobile phone:
          </div>
          <img
            src={qr5000}
            alt="QR code for 5000 payment"
            style={{ maxWidth: '220px', width: '100%', height: 'auto', border: '1px solid #eee', borderRadius: '8px' }}
          />
        </div>

        {preview && (
          <div style={{ marginTop: '20px' }}>
            <h3>Preview:</h3>
            <img
              src={preview}
              alt="Payment Slip Preview"
              style={{ maxWidth: '100%', height: '150px', border: '1px solid #ddd', borderRadius: '5px' }}
            />
          </div>
        )}
        <button type="submit" style={{ padding: '10px 20px', cursor: 'pointer', marginTop: '20px' }}>
          Verify Slip
        </button>
      </form>
      {message && (
        <p
          style={{
            marginTop: '10px',
            color: isSuccess ? 'green' : 'red',
          }}
        >
          {message}
        </p>
      )}
      <footer>
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="Logo 2" />
        <div>New Wave Consulting Group</div>
      </footer>
    </div>
  );
};

export default withRouter(UploadSlip5000);
